import http from '@/api/common'

export default {
  getScanTools() {
    return http.get('lookup/GetScanTools')
  },
  saveScanTool(data) {
    return http.post('lookup/SaveScanTool', data)
  },
  removeScanTool(id) {
    return http.get(`lookup/RemoveScanTool?id=${id}`)
  },
  getReportTemplates(area) {
    return http.get(`lookup/GetReportTemplates?area=${area}`)
  },
  saveReportTemplate(data) {
    return http.post('lookup/SaveReportTemplate', data)
  },
  removeReportTemplate(id) {
    return http.get(`lookup/RemoveReportTemplate?id=${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/report.js